import Shuffle from 'shufflejs';
window.addEventListener( 'load', init );
function init() {

    const element = document.querySelector('.directory');
    const elementWidth = element.offsetWidth;
    const sizer = element.querySelector('.directory-item');
    const searchFilterEl = document.querySelector('.directory-search-filter');
    const filterMobileTrigger = document.querySelector('.filter-trigger');
    const filterMobileClose = document.getElementById('filter-mobile-close');
    const sortOptionSelects = document.querySelectorAll('.sort-options');

    const cards = document.querySelectorAll( '.directory-item' );
    const heights = [];
    [...cards].forEach( card  => {

        const computed = window.getComputedStyle(card, null);

        const clientHeight = card.clientHeight;
        const spacing = parseFloat(computed.paddingTop) + parseFloat(computed.paddingBottom) + parseFloat(computed.marginTop) + parseFloat(computed.marginBottom);

        const memberMeta = card.querySelector('.directory-item-meta');
        const memberMetaHeight = memberMeta.offsetHeight;

        console.log(memberMetaHeight);

        heights.push( ( ( clientHeight + memberMetaHeight ) - spacing ) );
    });

    const cardHeight = Math.max(...heights);

    [...cards].forEach( card => {
        card.style.height = cardHeight + 'px';
    });

    const shuffleInstance = new Shuffle(element, {
        itemSelector: '.directory-item',
        sizer: sizer,
        speed: 150,
        delimiter: ','
    });

    filterMobileTrigger.addEventListener('click', handlefilterMobileTriggerAction);
    function handlefilterMobileTriggerAction(event) {
        searchFilterEl.classList.toggle('show');
    }

    filterMobileClose.addEventListener('click', handlefilterMobileTriggerClose);
    function handlefilterMobileTriggerClose(event) {
        console.log(event);
        searchFilterEl.classList.remove('show');
    }

    document.querySelector('.directory-search-input').addEventListener('search', resetShuffle);
    function resetShuffle(event) {
        if ( event.target.value === '' ) {
            shuffleInstance.filter();
        }
    }

    document.querySelector('.directory-search-input').addEventListener('keyup', handleSearchKeyup);
    function handleSearchKeyup(event) {
        const searchText = event.target.value.toLowerCase();

        shuffleInstance.filter((element, shuffle) => {

            const titleElement = element.querySelector('.directory-item__title');
            const titleText = titleElement.textContent.toLowerCase().trim();

            const organisationElement = element.querySelector('.directory-item__organisation');
            const organisationText = organisationElement.textContent.toLowerCase();

            const addressElement = element.querySelector('.directory-item__address');
            const addressText = addressElement.value.toLowerCase();

            const firstNameElement = element.querySelector('.first-name');
            const firstNameText = firstNameElement.textContent.toLowerCase();

            const lastNameElement = element.querySelector('.last-name');
            const lastNameText = lastNameElement.textContent.toLowerCase();

            console.log( addressText );
            console.log( searchText );

            if ( titleText.includes(searchText) ) {
                return true;
            }

            if ( organisationText.includes(searchText) ) {
               return true;
            }

            if ( addressText.includes(searchText) ) {
                return true;
            }

            if ( firstNameText.includes(searchText) ) {
                return true;
            }

            if ( lastNameText.includes(searchText) ) {
                return true;
            }

            return false;
        });
    }

    document.querySelector('.directory-sort-mobile').addEventListener('click', mobileSortAction);
    function mobileSortAction(event) {
        console.log(event.target);
        let value;

        if ( event.target.tagName === 'INPUT' ) {
            value = event.target.value;
        }

        function sortBySomethingElse(element) {
            return element.dataset.somethingElse;
          }
        
          function sortByTitle(element) {
            return element.dataset.title.toLowerCase();
          }

        let options;
        if (value === 'title-a-z') {
            options = {
                reverse: false,
                by: sortByTitle,
            };
        } else if (value === 'title-z-a') {
            options = {
                reverse: true,
                by: sortByTitle,
            };
        } else if (value === 'something-else') {
            options = {
                by: sortBySomethingElse,
            };
        } else {
            options = {};
        }
      
        shuffleInstance.sort(options);
    }

    [...sortOptionSelects].forEach( sortSelect => {
        sortSelect.addEventListener('change', handleSortChange.bind(this));
    });
    
    //document.querySelector('.sort-options').addEventListener('change', handleSortChange.bind(this));

    function handleSortChange(event) {

        const value = event.target.value;
        console.log(value);
      
        function sortBySomethingElse(element) {
          return element.dataset.somethingElse;
        }
      
        function sortByTitle(element) {
            console.log(element.dataset.title.toLowerCase().replace(',', ' '));
          return element.dataset.title.toLowerCase().replace(',', ' ');
        }
      
        let options;
        if (value === 'title-a-z') {
            options = {
                reverse: false,
                by: sortByTitle,
            };
        } else if (value === 'title-z-a') {
            options = {
                reverse: true,
                by: sortByTitle,
            };
        } else if (value === 'something-else') {
            options = {
                by: sortBySomethingElse,
            };
        } else {
            options = {};
        }

        console.log(options);
      
        shuffleInstance.sort(options);
    }

    const directoryFilters = document.querySelector( '.directory-filters' );
    directoryFilters.addEventListener( 'click', directoryFilterAction );
    
    function directoryFilterAction(event) {
        
        if ( event.target.tagName !== 'INPUT' ) {
            return false;
        }

        const parent = event.target.closest('.directory-filter-dropdown');
        const siblingFilters = parent.querySelectorAll('.directory-filter-checkbox');

        let groups = [];

        [...siblingFilters].forEach( filter => {
            if ( filter.checked ) {
                groups.push( filter.value );
            }
        });

        shuffleInstance.filter(groups);
    }

    directoryFilters.addEventListener('click', toggleFilterGroup );
    function toggleFilterGroup( event ) {

        console.log( event );
        if ( ! event.target.classList.contains('filter-header') ) {
            return false;
        }

        const filterGroups = document.querySelectorAll('.directory-filter-dropdown');
        [...filterGroups].forEach( group => {
            group.classList.remove('show');
        });

        const filterGroup = event.target.closest('.directory-filter');
        const dropdown = filterGroup.querySelector('.directory-filter-dropdown');
        dropdown.classList.add('show');

        document.body.addEventListener('click', function(event){
            if ( ! event.target.classList.contains('filter-header') && ! event.target.classList.contains('directory-filter-checkbox') && ! event.target.classList.contains('directory-filter') && ! event.target.classList.contains('directory-filter-label')) {
                dropdown.classList.remove('show');
            }
        });
    }

    shuffleInstance.on(Shuffle.EventType.LAYOUT, () => {

        const activeFilters = [];

        const filterGroups = directoryFilters.querySelectorAll('.directory-filter');
        [...filterGroups].forEach( group => {

            const groupName = group.dataset.groupName;
            const activeOptions = [];

            const checkboxes = group.querySelectorAll('input[type=checkbox]');
            [...checkboxes].forEach( checkbox => {
                if ( checkbox.checked ) {
                    activeOptions.push(checkbox.value);
                }
            });

            if ( groupName ) {
                activeFilters.push( { [groupName] : activeOptions } );
            }
        });

        console.log(activeFilters);
        createSelectedOptionsHTML(activeFilters);

        // const cards = document.querySelectorAll( '.directory-item' );
        // const heights = [];
        // [...cards].forEach( card  => {

        //     heights.push( card.offsetHeight );
        // });

        // console.log(heights);

        // const cardHeight = Math.max(...heights);

        // console.log(cardHeight);

        // [...cards].forEach( card => {
        //     card.style.height = cardHeight + 'px';
        // });
    });

    function createSelectedOptionsHTML(options) {

        const selectedOptionsEl = document.querySelector('#filter-selected-options');
        const clearOptions = document.querySelector('#options-clear-all');

        if ( clearOptions ) {
            clearOptions.remove();
        }

        selectedOptionsEl.innerHTML = '';

        const optionHTML = [];

        [...options].forEach( option => {

            const optionGroupName = Object.getOwnPropertyNames(option)[0];

            const optionGroupEl = document.createElement('div');
            optionGroupEl.classList.add('selected-options-group');

            const optionGroupNameEl = document.createElement('span');
            optionGroupNameEl.innerText = optionGroupName;

            const values = Object.values(option);

            values[0].forEach( value => {

                const valueEl = document.createElement('span');
                valueEl.innerText = value;
                valueEl.dataset.checkboxValue = value;

                const valueRemoveEl = document.createElement('span');
                valueRemoveEl.innerText = '✖';
                valueRemoveEl.classList.add('remove');

                valueEl.append(valueRemoveEl);
                optionGroupEl.append(valueEl);

                valueEl.addEventListener( 'click', function(event) {

                    const checkboxToRemove = event.target.dataset.checkboxValue;

                    const allCheckboxes = document.querySelectorAll('.directory-filter-checkbox');
                    [...allCheckboxes].forEach( checkbox => {
                        if ( checkbox.value === checkboxToRemove ) {
                            checkbox.click();
                            checkbox.checked = false;

                            event.target.remove();
                            shuffleInstance.update({force: true});
                        }
                    });
                });

            });

            selectedOptionsEl.append(optionGroupEl);
        });

        const selections = document.querySelectorAll('.selected-options-group span');
        
        const clearAllEl = document.createElement('button');
        clearAllEl.id = 'options-clear-all';
        clearAllEl.innerText = 'clear all';

        clearAllEl.addEventListener( 'click', function(event) {

            const allCheckboxes = document.querySelectorAll('.directory-filter-checkbox');

            [...allCheckboxes].forEach( checkbox => {
                checkbox.checked = false;
            });

            shuffleInstance.filter(Shuffle.ALL_ITEMS);
            clearAllEl.remove();
        });

        console.log(selections);

        if ( selections.length > 0 ) {
            selectedOptionsEl.append(clearAllEl);
        }
    }
}